import fetcher from '@/core/lib/fetcher'
import { queryOptions } from '@tanstack/react-query'
import { APIResponse } from '@/core/types/utils'
import { Restriction } from './restriction.types'

export const getRestrictions = (siteId: string, token: string) =>
  queryOptions({
    queryKey: ['restrictions', siteId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(
          import.meta.env.VITE_API_BOOKING + `property/${siteId}/restriction`
        )
        .json<Promise<APIResponse<Restriction[]>>>(),
  })
